module.exports = __webpack_public_path__ + "img/ST.74ab13c5.png";